<template>
    <div :class="$style.container">
        <el-menu
                :default-active="this.$route.path" router
                class="el-menu-vertical-demo a_menu"
                background-color="#f4f6f8" :default-openeds="keys"
                text-color="#303133" :unique-opened="true"
                active-text-color="#fff"
        >
            <el-submenu :index="index + 1+ ''" v-for="(item, index) in lists" :key="item.title">
                <template slot="title">
                    <span>{{item.title}}</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item :index="itemA.path" v-for="itemA in item.children" :key="itemA.text">{{itemA.text}}</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
        <div :class="$style.main">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {

                activeIndex: '1-0',
                keys: [
                    '1',
                    '2',
                    '3',
                    '4',
                    '5'
                ],
                lists: [
                    {
                        title: '巡店管理',
                        children: [
                            {
                                text: '基本信息',
                                path: '/cruiseShop/basicInfo'
                            },{
                                text: '检查事项',
                                path: '/cruiseShop/checkItems'
                            },{
                                text: '辅导评估',
                                path: '/cruiseShop/assessment'
                            }]
                    }
                ]
            }
        },
        methods: {
            // selectItems(url){
            //
            //     if(url === '/setting/settingOu'){
            //         this.imgUrl1 = organization_w
            //         this.imgUrl2 = information_b
            //     }else if(url === '/setting/settingPicture'){
            //         this.imgUrl1 = organization_b
            //         this.imgUrl2 = information_w
            //     }
            // }
        }
    }
</script>
<style lang="scss" module>
    .container {
        display: flex;
        flex-direction: row;
        .main {
            width: calc(100% - 200px);
            overflow: auto;
        }
        .first {
            padding-left: 10px;
            font-size: 16px;
        }
    }
</style>
<style scoped>
    .a_menu  {
        min-width: 200px;
        min-height: 100vh;
    }
    .a_menu >>> .el-menu {
        border:none;
    }
    .a_menu >>> .el-menu-item-group__title {
        padding: 0px;
    }
    .a_menu >>> .is-active {
        background: #3e9af4!important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/cruiseShop/index.vue